import { Hero } from "@/components/Hero";
import { TrustBar } from "@/components/TrustBar";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { MobilitySection } from "@/components/MobilitySection";
import { Timeline } from "@/components/Timeline";
import { Fleet } from "@/components/Fleet";
import { HumanAssistance } from "@/components/HumanAssistance";
import { QuoteForm } from "@/components/QuoteForm";
import { Reviews } from "@/components/Reviews";
import { OperationalArea } from "@/components/OperationalArea";
import { FAQ } from "@/components/FAQ";
import { FinalCTA } from "@/components/FinalCTA";
import { Seo, SITE_URL } from "@/components/Seo";
import { useLang } from "@/i18n/LanguageContext";
import { company } from "@/config/content";

export default function Home() {
  const { t, lang } = useLang();

  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "AutomotiveBusiness",
        name: company.name,
        image: `${SITE_URL}/og-image.jpg`,
        url: SITE_URL,
        telephone: company.phoneHref.replace("tel:", ""),
        email: company.email,
        areaServed: company.localities,
        address: { "@type": "PostalAddress", addressLocality: "Olbia", addressRegion: "Sardegna", addressCountry: "IT" },
        openingHours: "Mo-Su 00:00-23:59",
        priceRange: "€€",
      },
      {
        "@type": "FAQPage",
        mainEntity: t.faq.items.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
  };

  const title = lang === "en"
    ? "EMME SERVICE CAR | Roadside Assistance & Vehicle Transport in Olbia"
    : "EMME SERVICE CAR | Soccorso Stradale e Trasporto Veicoli a Olbia";
  const description = lang === "en"
    ? "Roadside assistance, recovery and transport of cars, motorcycles, campers, tractors, excavators and special vehicles. Call EMME SERVICE CAR or send your location on WhatsApp."
    : "Soccorso stradale, recupero e trasporto di auto, moto, camper, trattori, escavatori e veicoli speciali. Chiama EMME SERVICE CAR o invia la tua posizione su WhatsApp.";

  return (
    <>
      <Seo title={title} description={description} path="/" jsonLd={jsonLd} />
      <Hero />
      <TrustBar />
      <Services />
      <MobilitySection />
      <Marquee />
      <Timeline />
      <Fleet />
      <HumanAssistance />
      <QuoteForm />
      <OperationalArea />
      <Reviews />
      <FAQ />
      <FinalCTA />
    </>
  );
}
